import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: atob(process.env.REACT_APP_COLOR_PRIMARY),
      dark: atob(process.env.REACT_APP_COLOR_PRIMARY),
    },
    secondary: {
      main: atob(process.env.REACT_APP_COLOR_SECONDARY),
    },
    text: {
      primary: '#333',
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$active': {
          color: atob(process.env.REACT_APP_COLOR_PRIMARY),
        },
        '&$completed': {
          color: atob(process.env.REACT_APP_COLOR_PRIMARY),
        },
      },
    },
    MuiStepLabel: {
      label: {
        fontSize: '0.75rem',
        '&$active': {
          color: atob(process.env.REACT_APP_COLOR_PRIMARY),
        },
        '&$completed': {
          color: atob(process.env.REACT_APP_COLOR_PRIMARY),
        },
      },
    },
    MuiButton: {
      outlined: {
        borderRadius: 0,
        padding: '8px 8px',
        textTransform: 'none',
      },
    },
  },
  typography: {
    body1: {
      fontFamily: 'Open Sans, sans-serif',
      textTransform: 'none',
      fontWeight: 'bold',
    },
    h2: {
      fontFamily: 'Open Sans, sans-serif',
      fontWeight: 'bold',
      textAlign: 'center',
      textShadow: '0px 6px 14px rgba(24, 39, 75, 0.12)',
    },
    h3: {
      fontFamily: 'Open Sans, sans-serif',
    },
    h4: {
      fontFamily: 'Open Sans, sans-serif',
      fontWeight: 'bold',
      color: '#333333',
    },
    h5: {
      fontFamily: 'Open Sans, sans-serif',
    },
    h6: {
      fontFamily: 'Open Sans, sans-serif',
      // textTransform: 'uppercase',
      fontWeight: 'bold',
    },
    subtitle1: {
      color: '#d3d3d3',
    },
  },
});

export default theme;
